<template>
  <div class="settings-container">
    <!-- Manage applications section -->
    <div class="settings-section">
      <div class="section-header section-header-spec">
        <h3>Role title</h3>
        <el-select v-model="nowRole" class="spec-select" :reserve-keyword="false"
          placeholder="Search creator name or tag" @change="changeRole">
          <el-option v-for="item in props.list" :key="item.id" :label="item.role_name" :value="item.id" />
        </el-select>
      </div>

    </div>

  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { ElSelect, ElOption } from 'element-plus';
import { useRoute, useRouter } from "vue-router";
//
const props = defineProps({
  list: {
    type: Array,
    default: []
  }
});

const routerGo = useRouter();
const route = useRoute();
const nowRole = ref('');

watch(
  () => props.list,
  (newList) => {
    if (newList?.length) {
      const target = newList.find((item) => item.id == route.params.subtype);
      if (target) {
        nowRole.value = target.id; 
      }
    }
  },
  { immediate: true }
);

const changeRole = (id) => {
  window.location.href = `/settings/${route.params.type}/${id}`;
};
</script>

<style scoped></style>